import "core-js";
import i18next from "i18next";
import React, { StrictMode } from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import "./assets/scss/index.scss";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { goToPopup } from "./libs/services";
import { toast } from "./libs/utils";
import { EVENT_SW_CONFIRM, EVENT_SW_UPDATE } from "./constants/events";
import { POPUP_UPDATE, ROUTE_MESSENGER } from "./constants/routes";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorComponent } from "./components/layout/errors/boundary";
import AudioClass from "./libs/audio-player";
import { migrateStorage } from "./libs/storage";
import MemoryHistoryUtils from "./libs/memoryHistory";
import MockSocketClient from "./libs/Api/client-mock";
import store from "./store";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import Layout from "./containers/layout";
import MainRoutes from "./routes";
import { getUser } from "./store/users/actions";

export const memoryHistory = new MemoryHistoryUtils();
const locale = i18next.language?.substring(0, 2);

// window.onpopstate = function () {
//   if (agentDevice() === Device.MOBILE && !memoryHistory.location.search) {
//     goToMessenger();
//   }
// };

window.addEventListener("offline", function (e) {
  toast(<span className={locale === "fa" ? "rtlLoading" : "loading"}>{i18next.t("global.connection_faild")}</span>, {
    variant: "warning",
    persist: true,
  });
});

// console.log = console.warn = console.error = console.debug = () => {};
if (window.Cypress) {
  MockSocketClient.getInstance();
}
AudioClass.init();
migrateStorage();

render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={ErrorComponent} onReset={() => (window.location.href = ROUTE_MESSENGER)}>
      <Provider store={store}>
        <I18nextProvider i18n={i18next}>
          <BrowserRouter>
            <Layout>
              <MainRoutes />
            </Layout>
          </BrowserRouter>
        </I18nextProvider>
      </Provider>
    </ErrorBoundary>
  </StrictMode>,
  document.getElementById("root")
);

document.addEventListener(EVENT_SW_UPDATE, () => {
  toast("Checking for new updates ...", { variant: "info", autoHideDuration: 2 });
});

document.addEventListener(EVENT_SW_CONFIRM, () => {
  if (window.location.href.includes(ROUTE_MESSENGER)) goToPopup(POPUP_UPDATE);
});

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // store.dispatch(setUpdateAvailable(true));
  },
});

reportWebVitals();
